import type { SvgIconComponent } from "@mui/icons-material";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Link as RouterLink } from "react-router";
import useClientContext from "../../../contexts/useClientContext";
import { useImpersonationPageStatus } from "../../../hooks/useImpersonationPageStatus";
import type { InvestorRelationPortalFeatures } from "../../../store/state/user/types";
import PageStatusIndicator from "../../common/PageStatusIndicator";

interface Props {
  title: string;
  Icon: SvgIconComponent;
  pageName: string;
  currentPage?: string;
  requiredFeature?: InvestorRelationPortalFeatures;
}

const MenuPageItem = ({ title, Icon, pageName, currentPage, requiredFeature }: Props) => {
  const { isFeatureEnabled } = useClientContext();

  const impersonationPageStatus = useImpersonationPageStatus(requiredFeature);

  if (requiredFeature && !isFeatureEnabled(requiredFeature)) {
    return null;
  }

  return (
    <MenuItem
      component={RouterLink}
      to={pageName}
      selected={currentPage === pageName}
      sx={(theme) => ({
        borderRadius: theme.spacing(0.5),
        py: theme.spacing(1),
        color: theme.palette.text.secondary,
      })}
    >
      <ListItemIcon>
        <Icon color={currentPage === pageName ? "primary" : "secondary"} />
      </ListItemIcon>
      <ListItemText>{title}</ListItemText>
      {impersonationPageStatus && (
        <ListItemIcon sx={{ justifyContent: "flex-end" }}>
          <PageStatusIndicator status={impersonationPageStatus} />
        </ListItemIcon>
      )}
    </MenuItem>
  );
};

export default MenuPageItem;
